export function Loader({ fullScreen = false }: { fullScreen?: boolean }) {
  const inner = (
    <div className="relative flex items-center justify-center">
      {/* Pulsing amber glow */}
      <div className="absolute w-24 h-24 rounded-full loader-glow" />

      {/* Spinning + pulsing stamp token (no outer rect — just the circular amber stamp) */}
      <svg
        viewBox="0 0 200 200"
        className="relative w-16 h-16 loader-spin-pulse"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Amber circle */}
        <circle cx="100" cy="100" r="78" fill="#f59e0b" />
        {/* Perforations */}
        <circle cx="100.0" cy="22.0"   r="4.6" fill="#1c1917" />
        <circle cx="124.1" cy="25.82"  r="4.6" fill="#1c1917" />
        <circle cx="145.85" cy="36.9"  r="4.6" fill="#1c1917" />
        <circle cx="163.1" cy="54.15"  r="4.6" fill="#1c1917" />
        <circle cx="174.18" cy="75.9"  r="4.6" fill="#1c1917" />
        <circle cx="178.0" cy="100.0"  r="4.6" fill="#1c1917" />
        <circle cx="174.18" cy="124.1" r="4.6" fill="#1c1917" />
        <circle cx="163.1" cy="145.85" r="4.6" fill="#1c1917" />
        <circle cx="145.85" cy="163.1" r="4.6" fill="#1c1917" />
        <circle cx="124.1" cy="174.18" r="4.6" fill="#1c1917" />
        <circle cx="100.0" cy="178.0"  r="4.6" fill="#1c1917" />
        <circle cx="75.9"  cy="174.18" r="4.6" fill="#1c1917" />
        <circle cx="54.15" cy="163.1"  r="4.6" fill="#1c1917" />
        <circle cx="36.9"  cy="145.85" r="4.6" fill="#1c1917" />
        <circle cx="25.82" cy="124.1"  r="4.6" fill="#1c1917" />
        <circle cx="22.0"  cy="100.0"  r="4.6" fill="#1c1917" />
        <circle cx="25.82" cy="75.9"   r="4.6" fill="#1c1917" />
        <circle cx="36.9"  cy="54.15"  r="4.6" fill="#1c1917" />
        <circle cx="54.15" cy="36.9"   r="4.6" fill="#1c1917" />
        <circle cx="75.9"  cy="25.82"  r="4.6" fill="#1c1917" />
        {/* Inner dark circle */}
        <circle cx="100" cy="100" r="61" fill="#1c1917" />
        {/* Amber stamp dots */}
        <circle cx="129.44" cy="117" r="8.4" fill="#f59e0b" />
        <circle cx="100"    cy="134" r="8.4" fill="#f59e0b" />
        <circle cx="70.56"  cy="117" r="8.4" fill="#f59e0b" />
        <circle cx="70.56"  cy="83"  r="8.4" fill="#f59e0b" />
        <circle cx="100"    cy="66"  r="8.4" fill="#f59e0b" />
        {/* Spark */}
        <path d="M 129.44 72.0 L 132.41 80.03 L 140.44 83.0 L 132.41 85.97 L 129.44 94.0 L 126.47 85.97 L 118.44 83.0 L 126.47 80.03 Z" fill="#f59e0b" />
      </svg>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-stone-900">
        {inner}
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-24">
      {inner}
    </div>
  );
}
